import { render, staticRenderFns } from "./trawl-delivery-manual-tracking.vue?vue&type=template&id=36653907"
import script from "./trawl-delivery-manual-tracking.vue?vue&type=script&lang=js"
export * from "./trawl-delivery-manual-tracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports